module.exports = __webpack_public_path__ + "media/photo/ETS-Logo---RGB-Blue@2x-07744cb2.png";